import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"
import { LoaderCircleIcon } from "lucide-react";

const buttonVariants = cva(
   "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none  [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 cursor-pointer group relative disabled:opacity-50 disabled:bg-gray-400 font-semibold user-select-none user-none",
   {
      variants: {
         variant: {
            default:
               "bg-primary text-primary-foreground shadow hover:bg-primary/90",
            destructive:
               "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
            outline:
               "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
            secondary:
               "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline",
         },
         size: {
            default: "h-9 px-4 py-2",
            sm: "h-8 rounded-md px-3 text-xs",
            lg: "h-10 rounded-md px-8",
            icon: "h-9 w-9",
         },
      },
      defaultVariants: {
         variant: "default",
         size: "default",
      },
   }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, isPending = false, children, ...props }, ref) => {
   const Comp = asChild ? Slot : "button"
   let _props = {}
   if (isPending) {
      _props['data-loading'] = isPending
   }
   return (
      <Comp
         className={cn(buttonVariants({ variant, size, className }))}
         ref={ref}
         {..._props}
         {...props} >
         {isPending ? (
            <div className="absolute inset-0 flex items-center justify-center">
               <LoaderCircleIcon
                  className="animate-spin"
                  size={16}
                  aria-hidden="true"
               />
            </div>
         ) : null}
         <span className="w-full flex items-center justify-center gap-2 group-data-loading:text-transparent">{children}</span>
      </Comp>
   );
})
Button.displayName = "Button"

export { Button, buttonVariants }
